import {backboneViewProperties} from "../../decorators/backbone-properties";
import {UserHistoryItemView} from "../../user-history/views/user-history-item";
import {UserHistoryItemEmptyView} from "../../user-history/views/user-history-item-empty";
import {UserHistoryItemModel} from "../../user-history/models/user-history-item";
import Marionette from "../../shared/marionette-mustache";

interface JQuery {
    timeago(): void;
}
@backboneViewProperties({
    tagName: "ul",
    className: "user-history-items-list",
    childView: UserHistoryItemView,
    emptyView: UserHistoryItemEmptyView
})
export class UserHistoryItemsView extends Marionette.CollectionView<UserHistoryItemModel, UserHistoryItemView> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/user-history/views/user-history-items.ts